<template>
  <h5 class="mb-0 bold">いずれか選択してください</h5>
  <div
    class="yhc-kazai-entry-modal web-card"
    @click="webClick"
  >
    <div class="yhc-kazai-entry-modal--icon">
      <img src="/images/web.png" />
    </div>
    <div class="yhc-kazai-entry-modal--name">Webで申し込む</div>
  </div>
  <div
    class="yhc-kazai-entry-modal tel-card"
    @click="telClick"
  >
    <div class="yhc-kazai-entry-modal--icon">
      <img src="/images/tel.png" />
    </div>
    <div class="yhc-kazai-entry-modal--name">電話で申し込む</div>
  </div>
  <a
    :href="!isMobile ? item.linkInModal.web.pcHref : item.linkInModal.web.spHref"
    ref="webLink"
    target="_blank"
    rel="noopener"
    @click="sendGAEventAndCloseModal(item.linkInModal.web.ga4SendName)"
    style="display: none"
  ></a>
  <a
    :href="item.linkInModal.tel.href"
    ref="telLink"
    rel="noopener"
    @click="sendGAEventAndCloseModal(item.linkInModal.tel.ga4SendName)"
    style="display: none"
  ></a>
</template>
<script lang="ts">
import { $yhcGA4EventSender } from '../YhcEstimateFormFrontPage/YhcGA4EventSender'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    webClick() {
      this.$refs.webLink.click()
    },
    async telClick() {
      if (
        await $core.$toast.confirmDialog('電話申し込みを行います、よろしいですか？', {
          modalProps: { class: 'modal-confirm-dialog yhc-sms-service-info' },
        })
      ) {
        this.$refs.telLink.click()
      }
    },
    sendGAEventAndCloseModal(ga4SendName: string) {
      $yhcGA4EventSender.linkClickFromSmsServiceInfoPage(ga4SendName)
      // このモーダルを閉じる
      $core.$modals.closeModal('kazaiModal')
    },
  },
}
</script>
<style lang="scss">
/* 共通のカードスタイル */
.yhc-kazai-entry-modal {
  display: flex;
  align-items: center;
  margin: 15px;
  border-radius: 40px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5);
  border: 3px solid;
  cursor: pointer;
  overflow: hidden;

  .yhc-kazai-entry-modal--icon {
    padding: 6px;
    width: 70px;
    text-align: center;

    img {
      width: 30px;
    }
  }

  .yhc-kazai-entry-modal--name {
    flex-grow: 1;
    padding: 9px;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    letter-spacing: 0.1em;
  }
}

/* Web申し込みカード固有のスタイル */
.web-card {
  border-color: var(--yhc-color);

  .yhc-kazai-entry-modal--icon {
    background-color: var(--yhc-color);
  }

  .yhc-kazai-entry-modal--name {
    color: var(--yhc-color);
  }

  .yhc-kazai-entry-modal--name:hover {
    background-color: var(--yhc-color);
    color: white;
  }
}

/* 電話申し込みカード固有のスタイル */
.tel-card {
  border-color: var(--yhc-color-gray);

  .yhc-kazai-entry-modal--icon {
    background-color: var(--yhc-color-gray);
  }

  .yhc-kazai-entry-modal--name {
    color: var(--yhc-color-gray);
  }

  .yhc-kazai-entry-modal--name:hover {
    background-color: var(--yhc-color-gray);
    color: white;
  }
}

/* modal-header上書き */
.modal-header {
  padding: 0.5rem 1rem !important;
}

.yhc-sms-service-info .btn-success {
  background-color: var(--yhc-color);
  color: white;
  border-color: var(--yhc-color);
}

.yhc-sms-service-info .btn-success:hover {
  background-color: var(--yhc-color);
  opacity: 0.6;
  color: white;
  border-color: var(--yhc-color);
}
</style>
